'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Module4App2 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module4,
    app: state.moduleData.data.module4.app2,
    profile: state.profile.data
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module4App2, _Component);

  function Module4App2() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module4App2);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module4App2.__proto__ || (0, _getPrototypeOf2.default)(Module4App2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 4,
      appId: 2,
      module: 'Module 4',
      title: 'Overview',
      isCompleted: _this.props.app.isCompleted || false
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      _this.props.updateModuleApp(_this.props.user.userId, _this.state.moduleId, _this.state.appId, _this.state);

      // update the overarching module's details
      // this.props.updateModule(this.props.user.userId, this.state.moduleId, {
      //   'numAppCompleted': numAppCompleted,
      //   'numAppTotal': this.props.allModule.numAppTotal});

      // this.props.changeItem(this.state.moduleId, 0, this.state.appId + 1);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  /*
   * User types in something for what was
   * involved in the diet
   */


  (0, _createClass3.default)(Module4App2, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              this.state.module
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 12, sm: 12, xs: 12 },
              _react2.default.createElement(
                'h4',
                { className: styles.greenText },
                'In this module we will cover:'
              ),
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'Barriers to keeping fruit and vegetables stocked up and strategies to overcome these'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'Another strategy - getting support from other carers'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'Review of modules 1 to 3'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'Planning ahead'
                  )
                )
              )
            )
          ),
          _react2.default.createElement('div', { className: styles.spacer20 }),
          _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete })
        )
      );
    }
  }]);
  return Module4App2;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  changeItem: _propTypes2.default.func,
  profile: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module4App2;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/4/App/App2.js
// module id = 1207
// module chunks = 0